export const SAVING_FOR_WHOM_OPTIONS = {
  MYSELF: 'MYSELF',
  FAMILY_MEMBER: 'FAMILY_MEMBER',
};

export const HowToAddress = {
  FEMALE: 'F',
  MALE: 'M',
};

export const Gender = {
  FEMALE: 'F',
  MALE: 'M',
};

export const BeneficiaryOptions = {
  MYSELF: 'MYSELF',
  UNKNOWN: 'UNKNOWN',
  OTHERS: 'OTHERS',
};

export const MailingChannel = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  MAIL: 'MAIL',
};

export const SocialIdType = {
  BIOMETRIC: 'BIOMETRIC',
  STANDARD: 'STANDARD',
};

export const AVERAGE_COMMISSION_IN_PERCENTAGE = 0.7;
export const COMMISSION_IN_PERCENTAGE = 0.8;
export const YEARLY_MGMT_EXPECTED_FEES_IN_PERCENTAGE = 0.34;
const COMMISSION = COMMISSION_IN_PERCENTAGE / 100;
const YEARLY_YIELD = 4 / 100;
export const INTEREST_RATE = YEARLY_YIELD - COMMISSION;
